export default __webpack_public_path__ + "static/carousel-autoscar-13ae8e87358e0aff35828a00fb4552a1.png";